import React from 'react';

export const CustomPlanColumnSubtitle = () => (
  <p className="mt-5">
    <span className="fsz-16 center">
      For&nbsp;
      <span className="bold-800">10+</span>
      &nbsp;Users
    </span>
  </p>
);
